import React from 'react';
import {inject, observer} from 'mobx-react';
import {
  Modal, Button, Select, Row, Col, Input
  , Upload, Icon, message, Table
} from 'antd';
import {toJS} from 'mobx';

const Option = Select.Option;

@inject('homeStore')
@observer
class AppShare extends React.Component {
  render() {
    let {
      homeStore, homeStore: {
        setMobxState,
        appShare, appShare: {
          trade, function: fun, visible, title, otherTrade, otherFunction,
          selectedRowKeys, fileList, dataSource, dataSourceForTable, selectedRows
          , pageSize
        }
      }
    } = this.props;
    selectedRows = toJS(selectedRows);
    dataSourceForTable = toJS(dataSourceForTable);
    let me = !!localStorage.me ? JSON.parse(localStorage.me) : {role: ""};
    let access = !!localStorage.me && me.token ? me.token.access_token : '';
    const {datas, funcList} = this.getList();
    const props = {
      name: 'file',
      action: `${window.server}/v3/uploadApp?access_token=${access}`,
      fileList: toJS(fileList),
      onChange(info) {
        if (info.file.status === 'uploading') {
          homeStore.appShare.fileList = info.fileList;
        }
        if (info.file.status === 'done') {
          if (!Array.isArray(info.file.response)) {
            !info.file.response.status && message.info('文件格式有误，需为云商店导出的压缩包');
            setMobxState({ appShare: { ...toJS(appShare), fileList: fileList.slice(0, fileList.length - 1)} });
            return;
          }
          let len = info.file.response.length - 1;
          if (info.file.response[len] && info.file.response[len].status) {
            message.success(`${info.file.name} 上传成功!`)
            homeStore.appShare.sw_ids.push(info.file.response.sw_ids)
            homeStore.appShare.fileList = info.fileList;
            homeStore.appShare.dataSource = info.file.response.slice(0, len);
            let data = [];
            homeStore.appShare.dataSource.forEach((item, index) => {
              let temp = {
                key: index,
                name: '',
                trade: '',
                function: '',
                status: '已提交',
                isSubmit: false,
                sw_id: ''
              }
              for (let i in item) {
                temp.name = item[i];
                temp.sw_id = i;
              }
              data.push(temp);
            })
            homeStore.appShare.dataSourceForTable = data;
          } else {
            message.error(info.file.response.msg || `${info.file.name} 上传失败.`)
            homeStore.appShare.fileList = homeStore.appShare.fileList.filter(f => f.uid !== info.file.uid);
          }
        } else if (info.file.status === 'error') {
          message.error(`${info.file.name} 上传失败，请重试.`);
          homeStore.appShare.fileList = homeStore.appShare.fileList.filter(f => f.uid !== info.file.uid);
        }
      },
      onRemove(file) {
        homeStore.appShare.sw_ids = homeStore.appShare.sw_ids.filter(id => id !== file.response.sw_ids)
      }
    };
    const columns = [
      {
        key: 'name',
        title: '表单名称',
        dataIndex: 'name',
      },
      {
        key: 'trade',
        title: '行业',
        dataIndex: 'trade',
        render: (text, record) => {
          if (record.isSubmit) return <span>{text}</span>
        }
      },
      {
        key: 'function',
        title: '职能',
        dataIndex: 'function',
        render: (text, record) => {
          if (record.isSubmit) return <span>{text}</span>
        }
      },
      {
        key: 'status',
        title: '状态',
        dataIndex: 'status',
        render: (text, record) => {
          if (record.isSubmit) return <span>{text}</span>
        }
      }
    ];
    return (
      <Modal title={title} visible={visible}
             onCancel={this.handleCancel.bind(this)}
             footer={[
               <Button key='1' onClick={this.handleCancel.bind(this)}>返回</Button>
             ]}
             width={750}
             className='app-share'
      >
        {/*<Row className='app-share-row'>*/}
        {/*<Col span={3} offset={1}>*/}
        {/*表单名称：*/}
        {/*</Col>*/}
        {/*<Col span={20}>*/}
        {/*<Input placeholder="请输入表单名称"*/}
        {/*style={{width: '94%'}}*/}
        {/*value={appShare.name}*/}
        {/*onChange={(e) => {*/}
        {/*homeStore.appShare = { ...appShare, name: e.target.value }*/}
        {/*}}/>*/}
        {/*</Col>*/}
        {/*</Row>*/}
        <Row className='app-share-row'>
          <Col span={2}>
            <span className='app-share-label'> 文件：</span>
          </Col>
          <Col span={22}>
            <Upload {...props}>
              <Button>
                <Icon type="upload"/>
                上传附件
              </Button>
            </Upload>
            <div className='app-share-upload'>
              <a href='/files/ecfile/表单分享说明.docx' target='_blank'>附件说明</a>
              <a href='/files/ecfile/ecology.zip' target='_blank'
                 style={{marginLeft: 8}}
              > EC客户端（导出表单使用）</a>
            </div>
          </Col>
        </Row>
        {
          selectedRows && selectedRows.length !== 0 && (
            <div>
              <Row className='app-share-row'>
                <Col span={2}>
                  <span className='app-share-label'>行业：</span>
                </Col>
                <Col span={22}>
                  <Select mode="combobox"
                          placeholder="请选择行业"
                          style={{width: '52%'}}
                          onChange={this.handleChange.bind(this)}>
                    {
                      datas.map(({key,name}) => <Option key={key} value={name}>{name}</Option>)
                    }
                    <Option key="其他行业">其他行业</Option>
                  </Select>
                  <Input
                    value={otherTrade}
                    placeholder="请输入行业名称"
                    style={{width: '46%', marginLeft: '2%'}}
                    disabled={trade !== '其他行业'}
                    onChange={e => homeStore.appShare = {...appShare, otherTrade: e.target.value}}
                  />
                </Col>
              </Row>
              <Row className='app-share-row'>
                <Col span={2}>
                  <span className='app-share-label'>职能：</span>
                </Col>
                <Col span={22}>
                  <Select mode="combobox"
                          placeholder="请选择职能"
                          style={{width: '52%'}}
                          value={fun}
                          onChange={this.handleChange2.bind(this)}>
                    {
                      funcList.map(({key,name}) => <Option key={key} value={name}>{name}</Option>)
                    }
                    <Option key="其他职能">其他职能</Option>
                  </Select>
                  <Input
                    value={otherFunction}
                    placeholder="请输入职能名称"
                    style={{width: '46%', marginLeft: '2%'}}
                    disabled={fun !== '其他职能'}
                    onChange={e => homeStore.appShare = {...appShare, otherFunction: e.target.value}}
                  />
                </Col>
              </Row>
            </div>
          )
        }
        <Row className='app-share-btn'>
          <Col span={12}>
            <span style={{fontWeight: 'bolder', paddingLeft: 20}}>已上传附件表单</span>
          </Col>
          <Col span={12} style={{textAlign: "right"}}>
            <Button type='primary'
                    style={{marginRight: 20}}
                    disabled={appShare.selectedRows.length === 0}
                    onClick={this.handleOk.bind(this)}>分享</Button>
          </Col>
        </Row>
        <Row className='app-share-row' style={{marginTop: 0}}>
          <Col span={24}>
            <Table columns={columns}
                   pagination={{
                     pageSize:pageSize,
                     showSizeChanger: true,
                     showQuickJumper: true,
                     onShowSizeChange: (current, size) => {
                       homeStore.appShare.pageSize = size;
                     }
                   }}
                   dataSource={dataSourceForTable}
                   rowSelection={{
                     selectedRowKeys: selectedRowKeys,
                     onChange: (selectedRowKeys, selectedRows) => {
                       homeStore.appShare.selectedRowKeys = selectedRowKeys;
                       homeStore.appShare.selectedRows = selectedRows;
                     },
                     getCheckboxProps: record => ({
                       disabled: record.isSubmit,
                     }),
                   }}
                   locale={{
                     emptyText:
                       <div style={{fontSize: 12, color: 'rgba(0, 0, 0, 0.43)', textAlign: 'center'}}>
                         <Icon type="frown-o"/>
                         <span style={{marginLeft: 4}}>暂无数据</span>
                       </div>
                   }}
                   rowClassName={record => {
                     let bool = false;
                     dataSourceForTable.forEach(item => {
                       if (record.key === item.key) {
                         bool = record.isSubmit;
                       }
                     })
                     if (bool) return 'app-share-list-seleted ';
                     else return '';
                   }}
            />
          </Col>
        </Row>
      </Modal>
    )
  }

  getList() {
    const {homeStore: {appShare: {trade}, categoryDatas}} = this.props;
    const d = toJS(categoryDatas);
    let datas = [];
    let funcList = [];
    if (d[0]) datas = d[0].data[0].data;
    datas.forEach(({funcList: f, name: n}) => {
      trade === n && (funcList = [...f]);
    });
    return {
      datas,
      funcList,
    }
  }

  handleOk() {
    const {homeStore: {submitShare, appShare}} = this.props;
    // if (!appShare.name) {
    //   message.warning('名称不能为空！')
    // } else
    if ((!appShare.trade || appShare.trade === '其他行业') && !appShare.otherTrade) {
      message.warning('行业不能为空！')
    } else if ((!appShare.function || appShare.function === '其他职能') && !appShare.otherFunction) {
      message.warning('职能不能为空！')
    } else if (!appShare.sw_ids || appShare.sw_ids.length === 0) {
      message.warning('文件不能为空！')
    } else {
      // 其他职能必须放其他行业前，不然会被this.getList()刷成空，trade已变。。。这就是项目里双向数据的问题。
      if (appShare.function === '其他职能' || appShare.function === '') {
        appShare.functionName = appShare.otherFunction;
        appShare.function = '';
      } else {
        const functionObj = this.getList().funcList.filter(d => d.name === appShare.function)[0];
        appShare.functionName = appShare.function;
        appShare.function = functionObj ? functionObj.key : '';
      }
      if (appShare.trade === '其他行业' || appShare.trade === '') {
        appShare.tradeName = appShare.otherTrade;
        appShare.trade = '';
      } else {
        const tradeObj = this.getList().datas.filter(d => d.name === appShare.trade)[0];
        appShare.tradeName = appShare.trade;
        appShare.trade = tradeObj ? tradeObj.key : '';
      }
      // delete appShare.visible;
      // delete appShare.title;
      // delete appShare.fileList;
      const params = toJS(appShare);
      // params.sw_ids = `${params.sw_ids}`;
      appShare.selectedRows.forEach((item, index) => {
        params.sw_ids += item.sw_id;
        if (index !== appShare.selectedRows.length - 1)
          params.sw_ids += ',';
      })
      submitShare(params);
    }
  }

  handleCancel() {
    const {homeStore: {clearShare}} = this.props;
    clearShare();
  }

  handleChange(trade) {
    const {homeStore, homeStore: {appShare}} = this.props;
    homeStore.appShare = {...appShare, trade, function: ''};
  }

  handleChange2(value) {
    const {homeStore, homeStore: {appShare}} = this.props;
    homeStore.appShare = {...appShare, function: value};
  }
}

export default AppShare


// WEBPACK FOOTER //
// ./src/components/util/AppShare.js